import React, { useState, useEffect } from "react"
import Button from '@mui/material/Button';
import Card from "@mui/material/Card";
import CardHeader from '@mui/material/CardHeader';
import CardContent from "@mui/material/CardContent";
import { useNavigate } from "react-router-dom";
import {URL_API} from '../config/urls'

function DistVaf() {
	const autenticado = getAutenticado();
	const [dados, setDados] = useState({
			"login": "",
			"senha": ""});
	const nav = useNavigate();
	const config = {
		apiUrl: process.env.REACT_APP_URL_API,
	  };


	function alterarAf(e) {
		nav("/distvaf/editarAf/" + e);
		return null
	}

	function controlarItem(e) {
		setDados(_dados => ({ ...dados, [e.target.name]: e.target.value }))
		return null
	}

	function setAutenticado(valor) {
		sessionStorage.setItem('autenticado', valor);
		return null
	}

	function getAutenticado() {
		const usuarioLogado = sessionStorage.getItem('usuarioLogado');
        if (usuarioLogado != null) {
            return usuarioLogado;
        }
        else{
			if( !window.location.href.indexOf("atualizacaoSolicitar") > -1){
				//alert("Sessão expirada. Favor logar novamente.")
            	window.location.href = '/';
			}
        }
        return "";
	}

	function login(_e) {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const opcoes = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json',  "Authorization": `Bearer ${token_keycloack}` },
			body: JSON.stringify(dados)
		};
		fetch(`${URL_API}/api/v1/login/autenticar`, opcoes)
			.then(res => res.text())
			.then(_res => {
				if (_res === "OK") {
					setAutenticado(true)
				}
				else {
					setAutenticado(false)
				}
			})
			.catch(err => {
				console.error("Ocorreu um erro - " + err)
			});
		console.log("retorno: " + sessionStorage.getItem('autenticado'));
		return null
	}

	return (
		<div className="container-fluid">
			<div>
				<div className="row">
					<div className="col-12">
						<header className="main">
							<h2>DISTVAF</h2>
						</header>
					</div>
				</div>
					<div className="row">
						<div className="col-4">
							<Card variant="outlined">
								<CardHeader title="Arquivos" />
								<CardContent>
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/enviar")}>Envio</Button>&nbsp;
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/download")}>Download</Button>
								</CardContent>
							</Card>
						</div>
						<div className="col-4">
							<Card variant="outlined">
								<CardHeader title="Cadastros" />
								<CardContent>
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/prefeitura")}>Prefeitura</Button>&nbsp;
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/af")}>AF</Button>&nbsp;
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/srf")}>SRF</Button>
								</CardContent>
							</Card>
						</div>
						<div className="col-4">
							<Card variant="outlined">
								<CardHeader title="Outros" />
								<CardContent>
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/consultarEnvios")}>Consultas</Button>&nbsp;
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/enviarInformativo")}>Informativo</Button>&nbsp;
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/ajuda")}>Ajuda</Button>&nbsp;
								</CardContent>
							</Card>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Card variant="outlined">
								<CardHeader title="Atualização de Prefeituras" />
								<CardContent>
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/atualizacaoAprovar")}>Solicitações Aguardando Aprovação</Button>&nbsp;
									<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/atualizacaoVisualizar")}>Solicitações</Button>
								</CardContent>
							</Card>
						</div>
					</div>
			</div>
			
		</div>
		
	)
}

export default DistVaf;